import "./Level9.scss";

export default function Level9() {
  return (
    <div className="level9__container">
      <div className="level9__puzzle">
        <div className="level9__file">
          <p className="level9__clue">
            BYTE &nbsp; = &nbsp; 66 &nbsp; 89 &nbsp; 84 &nbsp; 69
          </p>
        </div>
      </div>

      <div className="level9__guess-container">
        <span className="level9__guess">65 &nbsp; 83 &nbsp; 67 &nbsp; 73 &nbsp; 73</span>
      </div>
    </div>
  );
}
